import css from 'styled-jsx/css';

export default css`.darkHeader {
  background-color: #414141;
  opacity: 0.9; }

.header {
  color: #ffffff;
  width: 100%;
  height: 8%;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
  margin-top: 30px;
  min-height: 60px;
  z-index: 2; }
  @media only screen and (max-width: 500px) {
    .header {
      z-index: 3;
      height: 70px;
      margin-top: 20px;
      position: -webkit-sticky;
      position: sticky;
      transition: unset; } }
  .header .wrap {
    max-width: 1440px;
    width: 80%;
    position: relative;
    display: flex;
    justify-content: space-between;
    margin: auto; }
    @media only screen and (max-width: 500px) {
      .header .wrap {
        height: 70px;
        width: 100%; } }
    .header .wrap .logo {
      position: relative; }
      @media only screen and (max-width: 500px) {
        .header .wrap .logo {
          left: 5%; } }
      .header .wrap .logo img {
        width: 160px; }
      .header .wrap .logo .pc {
        display: none; }
        @media only screen and (max-width: 500px) {
          .header .wrap .logo .pc {
            display: none; } }
      .header .wrap .logo .mob {
        display: none; }
        @media only screen and (max-width: 500px) {
          .header .wrap .logo .mob {
            display: block !important; } }
      .header .wrap .logo .show {
        display: block; }
        @media only screen and (max-width: 500px) {
          .header .wrap .logo .show {
            display: none; } }
    .header .wrap .pcMenu {
      position: relative;
      max-width: 500px;
      top: 0;
      display: flex;
      justify-content: space-around; }
      @media only screen and (max-width: 500px) {
        .header .wrap .pcMenu {
          display: none; } }
      .header .wrap .pcMenu span {
        position: relative;
        width: 107px;
        line-height: 60px;
        font-family: PingFangTC;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 1px;
        text-align: center;
        color: #ffffff;
        margin: auto 0;
        cursor: pointer; }
        .header .wrap .pcMenu span :hover {
          border-radius: 30px;
          border: solid 1px #ffffff;
          line-height: 35px;
          width: 105px; }
  .header .burger {
    flex-direction: column;
    position: absolute;
    top: 25%;
    cursor: pointer;
    right: 20%;
    display: none; }
    .header .burger input,
    .header .burger input:checked {
      display: block;
      opacity: 0;
      position: absolute;
      margin: 0;
      top: -25%;
      right: -25%;
      width: 150%;
      height: 150%;
      z-index: 3; }
    .header .burger span {
      border: 1px solid white;
      width: 90%;
      transition: transform 0.3s cubic-bezier(0.77, 0.2, 0.05, 1), background 0.3s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease; }
    .header .burger span:nth-last-child(1),
    .header .burger span:nth-last-child(3) {
      margin: 0; }
    .header .burger span:nth-last-child(2) {
      margin: auto 0; }
    .header .burger input:checked ~ span:nth-last-child(1) {
      transform: rotate(-45deg);
      top: 40%;
      position: absolute; }
    .header .burger input:checked ~ span:nth-last-child(2) {
      opacity: 0; }
    .header .burger input:checked ~ span:nth-last-child(3) {
      transform: rotate(45deg);
      top: 40%;
      position: absolute; }
    @media only screen and (max-width: 500px) {
      .header .burger {
        top: 50%;
        right: 8%;
        display: flex;
        /* cursor: pointer; */
        z-index: 5;
        transform: translate(10px, -50%);
        width: 5%;
        height: 30%; } }

.mobMenu {
  display: none; }
  @media only screen and (max-width: 800px) {
    .mobMenu {
      height: 100vh;
      width: 100vw;
      top: 0;
      justify-content: space-around;
      flex-direction: column;
      position: fixed;
      z-index: 2; } }
  .mobMenu .mask {
    height: 130vh;
    width: 100vw;
    position: absolute;
    background-color: #1a0e0a;
    opacity: 0.85;
    margin-top: -30px; }
  .mobMenu span {
    height: 20%;
    width: 100%;
    z-index: 3; }
    .mobMenu span p {
      position: relative;
      height: fit-content;
      text-align: center;
      color: white;
      height: 25vh;
      line-height: 25vh; }
`